import React from 'react'
import resolveProps from '../../../utils/resolveProps'
import { ButtonOwnProps , ButtonSizes} from './types'

const config = {
  types: [
    {
      title: 'primary',
      isDefault: true
    },
    'secondary',
    'primaryInverse',
    'secondaryInverse',
    'global',
    'icon',
    'iconText'
  ],
  modifiers: [
    {
      title: 'md',
      isDefault: true
    },
    'sm',
    'lg',
    'block'
  ],
  states: ['disabled']
}
type ButtonProps<E extends React.ElementType> = ButtonOwnProps<E> &
  Omit<React.ComponentProps<E>, keyof ButtonOwnProps>;

const defaultElement = "button";

export default function Button<E extends React.ElementType = typeof defaultElement>(props: ButtonProps<E> & (ButtonSizes)) {
  const {
    primary,
    secondary,
    primaryInverse,
    secondaryInverse,
    global,
    icon,
    iconName,
    iconText,
    md,
    sm,
    lg,
    block,
    children,
    disabled,
    data,
    href,
    target,
    onClick,
    gtm = {},
    ...rest
  } = props

  const TagName = href ? 'a' : 'button'
  const { gtmClassName = '', dataGTM = {} } = gtm

  return (
    <TagName
      {...rest}
      className={`${resolveProps(props, config, 'Button')} ${!!gtmClassName ? gtmClassName : ''}`}
      disabled={disabled}
      href={href}
      target={target}
      onClick={onClick}
      role={href ? 'link' : undefined }
      {...dataGTM}
    > {icon || iconText
      ? <><i className={`mdn-Icon-${iconName || 'fechar'} mdn-Icon--sm `}></i>
      <span>{children}</span></>
      : children
      }
    </TagName>
  )
}
